import { useState } from "react";
import { Download, FileSpreadsheet, CalendarDays, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const MESI = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];

function ultimiMesi(n = 12) {
  const out = [];
  const d = new Date();
  for (let i = 0; i < n; i++) {
    const m = new Date(d.getFullYear(), d.getMonth() - i, 1);
    out.push({ v: `${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, "0")}`, label: `${MESI[m.getMonth()]} ${m.getFullYear()}` });
  }
  return out;
}

export function ClienteExportDialog({ open, onClose, src, nome }) {
  const mesi = ultimiMesi(12);
  const [mese, setMese] = useState(mesi[0].v);
  const [busy, setBusy] = useState("");
  const base = (nome || "impianto").replace(/[^\w\- ]+/g, "").trim() || "impianto";
  const scarica = async (params, fname, tag) => {
    setBusy(tag);
    try {
      const blob = await src.exportCsv(params);
      const url = URL.createObjectURL(new Blob([blob], { type: "text/csv" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = fname;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch { toast.error("Esportazione non riuscita, riprova"); }
    setBusy("");
  };
  const meseLabel = mesi.find((m) => m.v === mese)?.label || mese;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="cliente-export-dialog" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Download className="h-5 w-5 text-sky-600" />Esporta i dati (CSV)</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="rounded-2xl border border-slate-200 p-3" data-testid="export-mese-card">
            <div className="flex items-center gap-2 text-sm font-bold text-slate-800"><FileSpreadsheet className="h-4 w-4 text-[#C17F59]" />Mese per mese</div>
            <p className="mt-1 text-xs text-slate-500">Riepilogo dell'anno in corso, un valore per ogni mese.</p>
            <button type="button" onClick={() => scarica({ tipo: "mese" }, `${base} - mese per mese.csv`, "mese")} disabled={!!busy} data-testid="export-mese-btn"
              className="mt-2 inline-flex items-center gap-2 rounded-full bg-sky-600 px-4 py-2 text-sm font-bold text-white transition-transform active:scale-95 disabled:opacity-50">
              {busy === "mese" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}Scarica</button>
          </div>
          <div className="rounded-2xl border border-slate-200 p-3" data-testid="export-giorno-card">
            <div className="flex items-center gap-2 text-sm font-bold text-slate-800"><CalendarDays className="h-4 w-4 text-[#C17F59]" />Giorno per giorno</div>
            <p className="mt-1 text-xs text-slate-500">Dettaglio giornaliero del mese scelto.</p>
            <div className="mt-2 flex items-center gap-2">
              <select value={mese} onChange={(e) => setMese(e.target.value)} data-testid="export-mese-select"
                className="min-w-0 flex-1 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 outline-none focus:border-sky-500">
                {mesi.map((m) => <option key={m.v} value={m.v}>{m.label}</option>)}
              </select>
              <button type="button" onClick={() => scarica({ tipo: "giorno", mese }, `${base} - ${meseLabel} giorno per giorno.csv`, "giorno")} disabled={!!busy} data-testid="export-giorno-btn"
                className="inline-flex shrink-0 items-center gap-2 rounded-full bg-sky-600 px-4 py-2 text-sm font-bold text-white transition-transform active:scale-95 disabled:opacity-50">
                {busy === "giorno" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}Scarica</button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
